import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useNotificationApi } from '../api';
import { notificationsKeys } from '../notifications-query-key-factory';
import { NotificationPeerTypes, NotificationResponse } from '../types/notifications.types';

const useDeletePeerNotification = () => {
  const NotificationsApi = useNotificationApi();
  const queryClient = useQueryClient();
  const deletePeerNotification = async ({
    causeId,
    peerId,
    peerType,
  }: {
    causeId: string;
    peerId: string;
    peerType: NotificationPeerTypes;
  }) => {
    const { data } = await NotificationsApi.delete<NotificationResponse>(
      `/notifications/${peerType}/${peerId}?cause_id=${causeId}`
    );
    return data;
  };

  return useMutation({
    mutationFn: deletePeerNotification,
    onSuccess(_, variables) {
      const { causeId, peerId, peerType } = variables;
      const key = notificationsKeys.id(causeId)[peerType].id(peerId).all;
      queryClient.removeQueries({ queryKey: key });
    },
  });
};

export { useDeletePeerNotification };
